module.exports = __webpack_public_path__ + "img/myQuery.3b870cb4.png";